import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import type { Swiper as SwiperClass } from "swiper";
import { Pagination, Navigation } from "swiper/modules";
import { ChevronLeft, ChevronRight, Volume2, VolumeX } from "lucide-react";
import "./style.css";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

interface ShortVideo {
  id: string; // video ID dari YouTube Shorts
  title: string;
}

const shorts: ShortVideo[] = [
  { id: "rw_ML88Q374", title: "Clip Pendek 1" },
  { id: "Qz9KnQ--hXo", title: "Clip Pendek 1" },
  { id: "PXLpYkc_wKI", title: "Clip Pendek 1" },
  { id: "4mXf3bN3DDE", title: "Clip Pendek 1" },
  { id: "BrxfmdN3Lds", title: "Clip Pendek 1" },
  { id: "cCfP8nm-NS0", title: "Clip Pendek 2" },
  { id: "bV2p83Ye-28", title: "Clip Pendek 3" },
  { id: "yowc8xFEyJ8", title: "Clip Pendek 3" },
  { id: "yH2F9Bap2Lo", title: "Clip Pendek 3" },
  { id: "tLv_fLVsqsg", title: "Clip Pendek 3" },
];

const YoutubeShortsEmbed = () => {
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [muted, setMuted] = useState<boolean>(true);

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-lime-100 via-lime-50 to-white py-12 sm:py-16 md:py-20">
      {/* soft glow decoration */}
      <div className="pointer-events-none absolute -top-24 left-1/2 h-72 w-72 -translate-x-1/2 rounded-full bg-lime-300/30 blur-3xl" />

      <div className="relative mx-auto max-w-6xl px-4 sm:px-6">
        <h1 className="mb-10 text-center font-sora text-[26px] font-extrabold text-red-700 sm:text-[32px] md:text-[44px]">
          Konten Rakyat
          <br />
          <span className="text-lime-900">Kopdes Merah Putih</span>
        </h1>

        <Swiper
          modules={[Pagination, Navigation]}
          slidesPerView={1.15}
          centeredSlides
          spaceBetween={16}
          loop
          //   autoplay={{
          //     delay: 8000,
          //     disableOnInteraction: false,
          //   }}
          pagination={{
            clickable: true,
            el: ".shorts-pagination",
          }}
          navigation={{
            prevEl: ".shorts-prev",
            nextEl: ".shorts-next",
          }}
          onSlideChange={(swiper: SwiperClass) => setActiveIndex(swiper.realIndex)}
          breakpoints={{
            640: {
              slidesPerView: 2.2,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3.2,
              spaceBetween: 24,
            },
          }}
          className="!pb-12">
          {shorts.map((video, index) => (
            <SwiperSlide key={`${video.id}-${index}`}>
              <div className="mx-auto aspect-[9/16] w-full max-w-[280px] overflow-hidden rounded-[26px] bg-black shadow-[0_20px_45px_-15px_rgba(63,87,19,0.35)] ring-1 ring-black/5 transition-transform duration-300">
                {index === activeIndex ? (
                  <iframe
                    key={`${video.id}-${muted}`}
                    src={`https://www.youtube.com/embed/${video.id}?autoplay=1&mute=${muted ? 1 : 0}&loop=1&playlist=${video.id}&controls=1&playsinline=1`}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    className="h-full w-full"
                  />
                ) : (
                  <img alt="" src={`https://img.youtube.com/vi/${video.id}/hqdefault.jpg`} className="h-full w-full object-cover opacity-70" />
                )}
              </div>

              {/* <p className="mt-3 line-clamp-2 text-center font-sora text-[14px] font-semibold text-lime-950/80">{video.title}</p> */}
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="mt-2 flex w-full flex-col items-center gap-4">
          {/* Navigation pill: prev - dots - next dalam satu wadah */}
          <div className="flex items-center gap-3 rounded-full border border-lime-200/70 bg-white/80 px-3 py-2 shadow-[0_8px_24px_-12px_rgba(63,87,19,0.35)] backdrop-blur-sm">
            <button aria-label="Video sebelumnya" className="shorts-prev flex h-9 w-9 items-center justify-center rounded-full text-lime-700 transition hover:bg-lime-600 hover:text-white active:scale-95">
              <ChevronLeft size={18} />
            </button>

            <div className="shorts-pagination flex items-center gap-1.5" />

            <button aria-label="Video berikutnya" className="shorts-next flex h-9 w-9 items-center justify-center rounded-full text-lime-700 transition hover:bg-lime-600 hover:text-white active:scale-95">
              <ChevronRight size={18} />
            </button>
          </div>

          {/* Mute toggle terpisah, biar fungsinya beda gak nyampur sama navigasi */}
          <button
            onClick={() => setMuted((m) => !m)}
            className="flex items-center gap-2 rounded-full border border-lime-200/70 bg-white/80 px-4 py-2 text-[13px] font-semibold text-lime-800 shadow-sm backdrop-blur-sm transition hover:bg-lime-600 hover:text-white active:scale-95">
            {muted ? <VolumeX size={15} /> : <Volume2 size={15} />}
            {muted ? "Suara mati" : "Suara nyala"}
          </button>
        </div>
      </div>
    </section>
  );
};

export default YoutubeShortsEmbed;
